import styled from '@emotion/styled';

export const RewardProgressBarContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 1.5rem;
    margin-bottom: 20px;
    height: 50%;
    margin: auto;

    @media (max-width: 950px) {
        flex-direction: column;
    }
`;

export const LoyaltyProgressSubContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    .reward-logo {
        width: 200px;
        margin-bottom: 12px;
    }

    .reward-progress {
        height: 150px;
        width: 150px;
    }
    .progress-bar {
        background-color: #e0e0e0;
        height: 100%;
    }

    @media (max-width: 950px) {
        flex-direction: column;

        .info-container {
            margin-left: 0px;
            align-items: center;
        }
        .reward-progress-total-div {
            margin-top: 10px;
        }
    }
`;
export const StyledCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 16px;

    .info-item {
        margin: 5px 0;
        font-weight: 600;
    }
`;
export const Learn3XLink = styled.div`
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
`;
export const ProgressBarCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: black;

    .center-value-progress-bar-price {
        margin: 0;
    }
    .center-value-progress-bar-voucher {
        margin: 0;
        letter-spacing: 0.01em;
    }
`;
export const RewardProgressTotalContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .total-button {
        display: flex;
        align-items: center;
        background-color: #e5edf6;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
    .reward-subtitle {
        letter-spacing: 0;
        display: flex;
    }

    @media (max-width: 950px) {
        .reward-subtitle {
            letter-spacing: 0;
            display: flex;
            text-align: center;
        }
        margin-top: 10px;
    }
`;

export const RewardProgressTotalButtonWithIcon = styled.div`
    display: flex;
    align-items: center;
    background-color: #e5edf6;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    padding: 1rem;
    margin-bottom: 14px;

    @media (max-width: 950px) {
        margin-top: 14px;
    }
`;

export const IconContainer = styled.span`
    .info-icon {
        margin-left: 6px !important;
    }
    .loyalty-icon {
        height: 19px !important;
        width: 19px !important;
        margin-left: 6px !important;
    }
    .loyalty-warning-icon {
        height: 19px !important;
        width: 19px !important;
        margin-right: 6px !important;
    }
    .outline-exclamation-icon {
        height: 48px !important;
        width: 48px !important;
    }
`;

export const SeparatorCard = styled.div`
    position: absolute;
    height: 100%;
`;

export const SeparatorInnerCard = styled.div`
    background: #fff;
    width: 6px;
    height: 17%;
`;

export const TooltipStyles = {
    tooltip: {
        sx: {
            color: '#FFFFFF',
            backgroundColor: '#252525',
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            '& .MuiTooltip-arrow': {
                color: '#252525',
            },
        },
    },
};
